import _taggedTemplateLiteral from "/builds/schumacherweb/devbridge/scp-web-client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  align-items: stretch;\n  display: flex;\n  flex-direction: column;\n  flex-grow: 1;\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: block;\n  height: 28px;\n  text-align: center;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import React from 'react';
import styled from 'styled-components';
var DateDisplay = styled.span(_templateObject());
var BaseDay = styled.div(_templateObject2());
export var Day = function Day(_ref) {
  var day = _ref.day,
      children = _ref.children;
  var dateValue = day && day.getDate().toString();
  return React.createElement(BaseDay, null, React.createElement(DateDisplay, null, dateValue), children);
};